import React, { Suspense, useEffect, useState } from 'react';
import Modal from '@/components/organisms/Modal/Modal';
import { OPEN_MODAL_EVENT, ModalEventDetail } from './modal-bus';
import { getIsland } from './registry';

interface ActiveModal {
    name: string;
    props: Record<string, unknown>;
}

export const ModalHost: React.FC = () => {
    const [active, setActive] = useState<ActiveModal | null>(null);

    useEffect(() => {
        const handleOpen = (e: Event) => {
            const { name, props } = (e as CustomEvent<ModalEventDetail>).detail;
            setActive({ name, props });
        };
        document.addEventListener(OPEN_MODAL_EVENT, handleOpen);
        return () => document.removeEventListener(OPEN_MODAL_EVENT, handleOpen);
    }, []);

    if (!active) return null;

    const Component = getIsland(active.name);
    if (!Component) return null;

    return (
        <Modal closeModal={() => setActive(null)}>
            {/* Suspense обязателен: модальные острова теперь ленивые (React.lazy),
                их чанк грузится при первом открытии. fallback=null — модалка уже
                показывает свой контейнер, пустого мелькания контента почти нет. */}
            <Suspense fallback={null}>
                <Component {...active.props} />
            </Suspense>
        </Modal>
    );
};
